import { TenderMethod } from '@rygen/rygen-ui/model';

import { ReferenceNumber } from '../ReferenceNumber';

export class TenderAcceptRequest {
  responseMethod: TenderMethod;
  referenceNumbers: ReferenceNumber[];
  comment?: string;
  accessToken?: string;

  constructor(
    responseMethod: TenderMethod,
    referenceNumbers?: ReferenceNumber[],
    comment?: string,
    accessToken?: string,
  ) {
    this.responseMethod = responseMethod;
    this.referenceNumbers = referenceNumbers || [];
    this.comment = comment;
    this.accessToken = accessToken;
  }
}
